import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ROLES_AND_PERMISSIONS_ROUTE_NAME = Symbol('admin.roles-and-permissions');

export const TRANSLATION_GROUP_ROLES_AND_PERMISSIONS = Symbol('admin.roles-and-permissions');

export const LIST_REPORT_NAMES_API_URL = 'admin/project_settings/list_report_fields';
export const REPORT_FIELDS_API_URL = 'admin/project_settings/report_fields';
export const ROLE_PERMISSIONS_API_URL = 'admin/roles/:roleId/permissions/list';
export const ROLES_AND_TREE_API_URL = 'admin/roles/list';
export const CREATE_ROLE_API_URL = 'admin/roles';
export const ADD_REPORT_COLUMN_API_URL = 'admin/project_settings/add_report_fields';
export const REMOVE_REPORT_COLUMN_API_URL = 'admin/project_settings/remove_report_fields';
export const SAVE_ROLE_PERMISSIONS_API_URL = 'admin/roles/:roleId/permissions/save';

export const LIST_REPORT_NAMES_QUERY = 'list-report-fields';
export const REPORT_FIELDS_QUERY = 'list-report-fields';
export const ROLE_PERMISSIONS_QUERY = 'role-permissions';
export const ROLES_AND_TREE_QUERY = 'roles-and-tree';

export const CREATE_ROLE_MUTATION = 'create-role';
export const ADD_REPORT_COLUMN_MUTATION = 'add-report-column';
export const REMOVE_REPORT_COLUMN_MUTATION = 'remove-report-column';
export const SAVE_ROLE_PERMISSIONS_MUTATION = 'save-role-permissions';

export const ROLES_PERMISSIONS = {
  ROLES_CREATE: new Permission(
    PermissionsList.admin.ROLES_CREATE,
  ),
  REPORT_FIELDS: new Permission(
    PermissionsList.admin.PROJECTSETTINGS_REPORT_FIELDS,
  ),
};
